/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Download3': {
    width: 12,
    height: 9,
    viewBox: '0 0 12 9',
    data: '<path pid="0" d="M3.55 7.8h-.495C1.688 7.8.58 6.68.58 5.3a2.49 2.49 0 012.31-2.495A3.463 3.463 0 016.025.8c1.746 0 3.19 1.304 3.43 3h.035a1.99 1.99 0 011.98 2c0 1.105-.886 2-1.98 2H8.5M4.469 5.564l1.555 1.458m0 0L7.58 5.564M6.024 7.022V3.133" _stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
